import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const passportDataEntity: Entity = {
  model: model,
  repository: repository,
}

export default passportDataEntity
